import React, {useEffect, useState} from "react";
import {ComponentHeader, MainContainer, SearchContainer} from "./styles";
import Button from "../../common/atoms/button";
import AddSubscriptionPlanModal from "../../components/AddSubscriptionPlanModal";
import TableComponent from "../../common/components/TableComponent";
import Utility from "../../utility";
import subscriptionPlans from "../../services/subscriptionPlans";

const SubscriptionPlans = (props) => {
    const [isVisible, setVisible] = useState(false)
    const [plans, setPlans] = useState([])

    const fetchSubscriptionPlans = async () => {
        let [err, subscriptionPlanList] = await Utility.parseResponse(subscriptionPlans.getPlansList(),);
        if (!subscriptionPlanList || err)
            return Utility.apiFailureToast("Unable to fetch plans");
        setPlans(subscriptionPlanList)
    }

    useEffect(() => {
        fetchSubscriptionPlans().then(() => 'Fetched')
    }, [])

    return (
        <>
            <AddSubscriptionPlanModal isVisible={isVisible} setVisible={setVisible}
                                      refreshPlans={fetchSubscriptionPlans}/>
            <MainContainer>
                <ComponentHeader>
                    <SearchContainer>
                        Subscription Plans
                    </SearchContainer>
                    <Button width='fit-content' onClick={() => setVisible(true)}>+ Add Plan</Button>
                </ComponentHeader>
                <TableComponent.Table cellpadding="0" cellspacing="0">
                    <TableComponent.TableHead>
                        <TableComponent.HeadColumn>Razorpay Plan Id</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Name</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Scope</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Description</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Amount</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>No of Months</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Status</TableComponent.HeadColumn>
                    </TableComponent.TableHead>
                    <TableComponent.TableBody>
                        {plans?.map((item) => (
                            <TableComponent.BodyRow key={item._id}>
                                <TableComponent.BodyColumn>{item.razorPayPlanId}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.name}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.scope}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.description}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.price === 0 ? 'Free' : `₹${item.price}`}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.noOfDays === -1 ? 'Lifetime' : `${item.noOfDays/30} Months`}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.isInactive ? "Inactive" : "Active"}</TableComponent.BodyColumn>
                            </TableComponent.BodyRow>
                        ))}
                    </TableComponent.TableBody>
                </TableComponent.Table>

            </MainContainer>
        </>
    )
}
export default SubscriptionPlans;
